import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import WhatsAppIcon from "./WhatsAppIcon";
import { goTo, WHATSAPP_URL } from "@/lib/scroll";

const LINKS = [
  ["Sintomas", "#sintomas"],
  ["Sobre", "#sobre"],
  ["Diferencial", "#diferencial"],
  ["Consulta", "#consulta"],
  ["Depoimentos", "#depoimentos"],
  ["Dúvidas", "#faq"],
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, hash) => {
    setOpen(false);
    goTo(hash)(e);
  };

  return (
    <>
      <header
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
          scrolled ? "bg-[#ebebeb]/95 backdrop-blur-md shadow-lg shadow-black/10" : "bg-[#ebebeb]/90 backdrop-blur-sm"
        }`}
      >
        <div className="mx-auto max-w-[1240px] px-5 md:px-10 h-[76px] flex items-center justify-between">
          <Logo />
          <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
            {LINKS.map(([label, hash]) => (
              <a
                key={hash}
                href={hash}
                onClick={(e) => go(e, hash)}
                className="text-olive/80 hover:text-terra text-sm font-medium tracking-wide transition-colors duration-300"
              >
                {label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-cta-whatsapp"
              className="hidden sm:inline-flex items-center gap-2.5 rounded-full bg-sun px-6 py-3 text-sm font-bold text-olive transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-sun/25"
            >
              <WhatsAppIcon className="size-4" />
              Agendar consulta
            </a>
            <button
              onClick={() => setOpen(true)}
              data-testid="mobile-menu-open"
              aria-label="Abrir menu"
              className="lg:hidden inline-flex size-11 items-center justify-center rounded-full border border-olive/30 text-olive transition hover:bg-olive/10"
            >
              <Menu className="size-5" />
            </button>
          </div>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-[90] bg-olive-deep flex flex-col" data-testid="mobile-menu">
          <div className="flex h-[76px] items-center justify-between px-5 md:px-10">
            <Logo />
            <button
              onClick={() => setOpen(false)}
              data-testid="mobile-menu-close"
              aria-label="Fechar menu"
              className="inline-flex size-11 items-center justify-center rounded-full border border-cream/25 text-cream transition hover:bg-cream/10"
            >
              <X className="size-5" />
            </button>
          </div>
          <nav className="flex flex-1 flex-col justify-center gap-2 px-8">
            {LINKS.map(([label, hash], i) => (
              <a
                key={hash}
                href={hash}
                onClick={(e) => go(e, hash)}
                className="font-display text-4xl sm:text-5xl text-cream/90 hover:text-sun py-2 transition-colors"
                style={{ transitionDelay: `${i * 30}ms` }}
              >
                {label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-menu-whatsapp"
              className="mt-8 inline-flex w-fit items-center gap-3 rounded-full bg-sun px-8 py-4 text-lg font-bold text-olive"
            >
              <WhatsAppIcon className="size-5" />
              Agendar pelo WhatsApp
            </a>
          </nav>
        </div>
      )}
    </>
  );
}
